import React, { createContext, ReactNode, useContext, useReducer } from 'react';

import {
  PackagesAction,
  packagesInitState,
  packagesReducer,
  PackagesState,
} from 'leash/reducers/packages/PackagesReducer';

type DispatchPackages = (action: PackagesAction) => void;

const PackagesContext = createContext<
  { state: PackagesState; dispatch: DispatchPackages } | undefined
>(undefined);

interface PackagesProviderProps {
  children: ReactNode;
  reducerInitialState?: PackagesState;
}

export function PackagesProvider(props: PackagesProviderProps) {
  const { children, reducerInitialState } = props;
  const initialState = reducerInitialState ?? packagesInitState;

  const [state, dispatch] = useReducer(packagesReducer, initialState);

  return (
    <PackagesContext.Provider value={{ state, dispatch }}>
      {children}
    </PackagesContext.Provider>
  );
}

export function usePackagesContext() {
  const context = useContext(PackagesContext);
  if (!context)
    throw new Error('usePackagesContext must be used within a PackagesProvider');
  return context;
}
